export default "__VITE_ASSET__0c1eb761__"